﻿import SearchService from '../../services/search-service';
import { pendingTask, begin, end } from 'react-redux-spinner';

let xmlActions = {
    startSearchAllocationsXmlRequest: function() {
        return {
            type: 'GET_ALLOCATION_AVAILABILITY_XML_REQUEST_BEGIN',
            xml: null,
            [pendingTask]: begin
        };
    },
    completeSearchAllocationsXmlRequest: function(xml) {
        return {
            type: 'GET_ALLOCATION_AVAILABILITY_XML_REQUEST_END',
            xml: xml,
            [pendingTask]: end
        };
    },
    getAllocationEnquiriesXmlRequest: function(search) {
        return (dispatch, getState) => {
            dispatch(xmlActions.startSearchAllocationsXmlRequest());
            let searchService = new SearchService(getState().oidc.user !== null ? getState().oidc.user.id_token : '');
            searchService
                .getAllocationEnquiriesXmlRequest(search)
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    dispatch(xmlActions.completeSearchAllocationsXmlRequest(data));
                })
                .catch((error) => {
                    dispatch(xmlActions.completeSearchAllocationsXmlRequest(''));
                    throw error;
                });
        };
    },
    startSearchHotelsXmlRequest: function(data) {
        return {
            type: 'GET_HOTEL_AVAILABILITY_XML_REQUEST_BEGIN',
            xml: data,
            [pendingTask]: begin
        };
    },
    completeSearchHotelsXmlRequest: function(xml) {
        return {
            type: 'GET_HOTEL_AVAILABILITY_XML_REQUEST_END',
            xml: xml,
            [pendingTask]: end
        };
    },
    getHotelAvailabilityXmlRequest: function(search) {
        return (dispatch, getState) => {
            dispatch(xmlActions.startSearchHotelsXmlRequest(getState().xml));
            let searchService = new SearchService(getState().oidc.user !== null ? getState().oidc.user.id_token : '');
            return searchService
                .getHotelAvailability(search)
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    dispatch(xmlActions.completeSearchHotelsXmlRequest(data));
                    return data;
                })
                .catch((error) => {
                    dispatch(xmlActions.completeSearchHotelsXmlRequest(''));
                    throw error;
                });
        };
    },
    clearXmlRequest: function() {
        return {
            type: 'CLEAR_XML_REQUEST',
            xml: null
        };
    }
};

export default xmlActions;
